import { Button, cn, Col, Row } from '@rematter/ui-web';
import { LucideArrowLeft } from 'lucide-react';

export type SettingsSubmoduleHeaderProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  tabs: React.ReactNode;
  children: React.ReactNode;
  onBackPressed?: () => void;
  className?: string;
  contentClassName?: string;
  tools?: React.ReactNode;
};

export const SettingsSubmodule = ({
  onBackPressed,
  tabs,
  children,
  title,
  subtitle,
  className,
  contentClassName,
  tools,
}: SettingsSubmoduleHeaderProps) => (
  <Col className={cn('@SettingsSubmodule h-full', className)}>
    <Col className="border-b border-neutral/15">
      <Row className={cn('px-5 pt-3')} gap3>
        {onBackPressed && (
          <Button
            variant="outline"
            onPress={onBackPressed}
            className={'px-3'}
            icon={<LucideArrowLeft className={'size-4.5'} />}
          />
        )}
        <Col className="flex-1">
          <div className={'text-lg font-semibold'}>{title}</div>
          <div className={'text-sm text-neutral/75'}>{subtitle}</div>
        </Col>
        {tools && (
          <div className="ml-auto flex items-center gap-2">{tools}</div>
        )}
      </Row>
      {tabs && (
        <Row className={'relative -mb-px px-5'} gap5>
          {tabs}
        </Row>
      )}
    </Col>
    <Col className={cn('h-full overflow-y-auto p-5', contentClassName)}>
      {children}
    </Col>
  </Col>
);
